
import { Space, Card } from 'antd';
import { StopOutlined } from "@ant-design/icons"
import { removeAdminUserSessionAsync } from '../../../../app/store/reducers/auth/authReducer';
import { useParams } from 'react-router-dom';



const SessionCard = ({session}) => {
    const {id} = useParams()


    const removeSession = ({id, token}) => {
        removeAdminUserSessionAsync({account_id: id, token: token})
    }
    const today = new Date()

    // const expiredDay = new Date(session?.expires_on).getTime()
    // const today = new Date().getTime()
    // const failed = today >= expiredDay
    // console.log(new Date().setHours(new Date().getHours() - 8))

    return (
    <>
        <Space direction="vertical" size={16}>
    <Card
    //   className={`border border-2 ${failed && "bg-danger text-white"}`}
    className={`border border-2`}
    //   title="Default size card"
      extra={<StopOutlined onClick={() => removeSession({id: id, token: session?.token})} style={{ fontSize: '20px', fontWeight: "bold", color: false ? "white" : 'red' }} />}
      style={{
        width: 350,
      }}
    >
      <p className="fw-bold m-0">Дата создания: <span className="fw-medium ms-1">{session?.created_at}</span></p>
      <p className="fw-bold m-0">Дата истечения: <span className="fw-medium ms-1">{session?.expires_on}</span></p>
      <p className="fw-bold m-0">IP адрес: <span className="fw-medium ms-1 text-info">{session?.ip_address}</span></p>
      {session?.referer &&
        <p className="fw-bold m-0">Referer: <span className="fw-medium ms-1">{session?.referer}</span></p>
      }
      <p className="fw-bold m-0">Пользовательский агент: <span className="fw-medium ms-1">{session?.user_agent}</span></p>
    </Card>
  </Space>
    </>
  )
}

export default SessionCard